import { memo } from 'react';
import { LIVE_REGION_IDS } from '../lib/announce';

/**
 * The two persistent live regions (§11b). Rendered empty in the shell at load and never re-mounted
 * (memo with no props; mounted above the router so route changes don't touch it).
 */
export const LiveRegions = memo(function LiveRegions() {
  return (
    <div className="sr-only">
      <div id={LIVE_REGION_IDS.polite} role="status" aria-live="polite" aria-atomic="true" />
      <div id={LIVE_REGION_IDS.assertive} role="alert" aria-live="assertive" aria-atomic="true" />
    </div>
  );
});
